import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RelatorioService } from 'src/app/service/relatorio.service';
import { SegmentoService } from 'src/app/service/segmento.service';
import { Segmento } from '../segmento/segmento';
import { DescricaoStatusTicket } from 'src/app/enum/statusTicket.enum';
import { DescricaoPrioridade } from 'src/app/enum/prioridade.enum';
import { DescricaoTipoTicket } from 'src/app/enum/tipoTicket.enum';

interface Opcao {
  valor: string;
  label: string;
}

@Component({
  selector: 'app-relatorios',
  templateUrl: './relatorios.component.html',
  styleUrls: ['./relatorios.component.scss'],
})
export class RelatoriosComponent implements OnInit {

  tipo = '';
  titulo = 'Relatório';
  icone = 'assessment';
  gerando = false;

  segmentos: Segmento[] = [];

  // Período (todos os relatórios)
  dataInicio: Date | null = null;
  dataFim: Date | null = null;

  // Contas
  tipoFiltro = '';
  pagador = '';
  ctSegmentoId: number | null = null;
  ctSituacao = '';

  situacaoReceberOpcoes: Opcao[] = [
    { valor: 'A_RECEBER', label: 'A Receber' },
    { valor: 'RECEBIDO', label: 'Recebido' },
    { valor: 'PAGO', label: 'Pago' },
    { valor: 'NEGOCIADO', label: 'Negociado' },
  ];
  situacaoPagarOpcoes: Opcao[] = [
    { valor: 'A_PAGAR', label: 'A Pagar' },
    { valor: 'PAGO', label: 'Pago' },
    { valor: 'NEGOCIADO', label: 'Negociado' },
  ];

  // Tickets
  tkId: number | null = null;
  tkSegmento = '';
  tkStatus = '';
  tkPrioridade = '';
  tkTipo = '';
  tkAssunto = '';

  // Clientes
  clParametro = '';

  statusOpcoes: Opcao[] = Array.from(DescricaoStatusTicket, ([valor, label]) => ({ valor, label }));
  prioridadeOpcoes: Opcao[] = Array.from(DescricaoPrioridade, ([valor, label]) => ({ valor, label }));
  tipoOpcoes: Opcao[] = Array.from(DescricaoTipoTicket, ([valor, label]) => ({ valor, label }));

  constructor(
    private route: ActivatedRoute,
    private relatorioService: RelatorioService,
    private segmentoService: SegmentoService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.tipo = data.tipo || '';
      this.configurar();
    });
  }

  private configurar(): void {
    this.tipoFiltro = '';
    this.ctSegmentoId = null;
    this.ctSituacao = '';
    switch (this.tipo) {
      case 'contasReceber':
        this.titulo = 'Relatório de Contas a Receber';
        this.icone = 'attach_money';
        this.segmentoService.listarAtivos().subscribe(segs => this.segmentos = segs || []);
        break;
      case 'contasPagar':
        this.titulo = 'Relatório de Contas a Pagar';
        this.icone = 'payments';
        this.segmentoService.listarAtivos().subscribe(segs => this.segmentos = segs || []);
        break;
      case 'tickets':
        this.titulo = 'Relatório de Tickets';
        this.icone = 'support_agent';
        this.segmentoService.listarAtivos().subscribe(segs => this.segmentos = segs || []);
        break;
      case 'clientes':
        this.titulo = 'Relatório de Clientes';
        this.icone = 'people_outline';
        break;
    }
  }

  gerar(): void {
    let obs: Observable<Blob>;
    const inicio = this.formatarData(this.dataInicio);
    const fim = this.formatarData(this.dataFim);
    switch (this.tipo) {
      case 'contasReceber':
        obs = this.relatorioService.contasReceber({
          dataInicio: inicio, dataFim: fim, tipoFiltro: this.tipoFiltro, pagador: this.pagador,
          segmentoId: this.ctSegmentoId, situacao: this.ctSituacao,
        });
        break;
      case 'contasPagar':
        obs = this.relatorioService.contasPagar({
          dataInicio: inicio, dataFim: fim, tipoFiltro: this.tipoFiltro, favorecido: this.pagador,
          segmentoId: this.ctSegmentoId, situacao: this.ctSituacao,
        });
        break;
      case 'tickets':
        obs = this.relatorioService.tickets({
          dataInicio: inicio, dataFim: fim, id: this.tkId, segmento: this.tkSegmento,
          status: this.tkStatus, prioridade: this.tkPrioridade, tipo: this.tkTipo, assunto: this.tkAssunto,
        });
        break;
      case 'clientes':
        obs = this.relatorioService.clientes({
          dataInicio: inicio, dataFim: fim, tipoFiltro: this.tipoFiltro, parametroConsulta: this.clParametro,
        });
        break;
      default:
        return;
    }
    this.executar(obs);
  }

  private executar(obs: Observable<Blob>): void {
    this.gerando = true;
    obs.subscribe(blob => {
      this.gerando = false;
      this.abrir(blob);
    }, () => {
      this.gerando = false;
      this.snackBar.open('Erro ao gerar o relatório.', 'ERRO', { duration: 3000 });
    });
  }

  private abrir(blob: Blob): void {
    const arquivo = new Blob([blob], { type: 'text/html' });
    const url = window.URL.createObjectURL(arquivo);
    const aba = window.open(url, '_blank');
    if (!aba) {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    }
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  }

  private formatarData(data: Date | null): string {
    if (!data) {
      return '';
    }
    const dia = ('0' + data.getDate()).slice(-2);
    const mes = ('0' + (data.getMonth() + 1)).slice(-2);
    return `${dia}/${mes}/${data.getFullYear()}`;
  }
}
